import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { VisualTestContainer } from '../../test/visual/VisualTestContainer';
import { FavoriteFill } from '@wix/wix-ui-icons-common/on-stage';
import { ProgressBar } from '..';

const Comp = (props) => (
  <VisualTestContainer>
    <ProgressBar {...props} />
  </VisualTestContainer>
);

visualize('ProgressBar', () => {
  story('simple example', () => {
    snap('default props', <Comp />);

    snap(
      'custom value with percentage',
      <Comp value={20} showProgressIndication />,
    );
    snap(
      'custom value with percentage and size large',
      <Comp value={20} showProgressIndication size="large" />,
    );

    snap(
      'custom value with prefix',
      <Comp
        value={20}
        prefixIndication={<FavoriteFill style={{ color: 'orange' }} />}
      />,
    );
    snap(
      'custom value with prefix and size large',
      <Comp
        value={20}
        prefixIndication={<FavoriteFill style={{ color: 'orange' }} />}
        size="large"
      />,
    );

    snap(
      'custom value with custom suffix',
      <Comp
        value={20}
        showProgressIndication
        customSuffixIndicationText="20"
      />,
    );
    snap(
      'custom value with custom suffix and size large',
      <Comp
        value={20}
        showProgressIndication
        customSuffixIndicationText="20"
        size="large"
      />,
    );

    snap('custom value 33%', <Comp value={33} showProgressIndication />);
    snap(
      'custom value 33% and size large',
      <Comp value={33} showProgressIndication size="large" />,
    );

    snap('custom value 100%', <Comp value={100} showProgressIndication />);
    snap(
      'custom value 100% and size large',
      <Comp value={100} showProgressIndication size="large" />,
    );

    snap(
      'custom value RTL',
      <div dir="rtl">
        <Comp value={100} showProgressIndication />
      </div>,
    );
    snap(
      'custom value RTL and size large',
      <div dir="rtl">
        <Comp value={100} showProgressIndication size="large" />
      </div>,
    );
    snap(
      'wst theme',
      <div
        style={
          {
            '--wst-paragraph-2-color-rgb': '255,200,0',
            '--wst-paragraph-2-font-style': 'italic',
            '--wst-paragraph-2-font-family': 'Courier New',
            '--wst-paragraph-2-font-weight': '900',
            '--wst-links-and-actions-color-rgb': '00,220,200',
            '--wst-paragraph-2-font-size': '22px',
            '--wst-paragraph-2-font-variant': 'small-caps',
            '--wst-paragraph-2-line-height': '3',
          } as React.CSSProperties
        }
      >
        <Comp value={60} showProgressIndication size="large" />
      </div>,
    );
  });
});
